import React from 'react';

// Composant pour afficher des motifs traditionnels sénégalais comme fond décoratif
const TraditionalPattern = ({ variant = 'circles', opacity = 0.1, className = '' }) => {
  const patterns = {
    circles: (
      <svg className={`absolute inset-0 w-full h-full ${className}`} style={{ opacity }}>
        <defs>
          <pattern id="traditional-circles" x="0" y="0" width="120" height="120" patternUnits="userSpaceOnUse">
            <circle cx="20" cy="20" r="15" fill="none" stroke="currentColor" strokeWidth="1.5" />
            <circle cx="20" cy="20" r="10" fill="none" stroke="currentColor" strokeWidth="1" />
            <circle cx="20" cy="20" r="5" fill="currentColor" />
            <circle cx="70" cy="70" r="18" fill="none" stroke="currentColor" strokeWidth="2" />
            <circle cx="70" cy="70" r="12" fill="none" stroke="currentColor" strokeWidth="1.5" />
            <circle cx="70" cy="70" r="6" fill="currentColor" />
            <circle cx="100" cy="30" r="12" fill="none" stroke="currentColor" strokeWidth="1.5" />
            <circle cx="100" cy="30" r="7" fill="currentColor" />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#traditional-circles)" />
      </svg>
    ),
    dots: (
      <svg className={`absolute inset-0 w-full h-full ${className}`} style={{ opacity }}>
        <defs>
          <pattern id="traditional-dots" x="0" y="0" width="40" height="40" patternUnits="userSpaceOnUse">
            <circle cx="10" cy="10" r="2" fill="currentColor" />
            <circle cx="30" cy="10" r="1.5" fill="currentColor" />
            <circle cx="10" cy="30" r="1.5" fill="currentColor" />
            <circle cx="30" cy="30" r="2.5" fill="currentColor" />
            <circle cx="20" cy="20" r="1" fill="currentColor" />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#traditional-dots)" />
      </svg>
    ),
    waves: (
      <svg className={`absolute inset-0 w-full h-full ${className}`} style={{ opacity }}>
        <defs>
          <pattern id="traditional-waves" x="0" y="0" width="100" height="50" patternUnits="userSpaceOnUse">
            <path d="M0 25 Q 25 15, 50 25 T 100 25" stroke="currentColor" strokeWidth="2" fill="none" />
            <path d="M0 35 Q 25 25, 50 35 T 100 35" stroke="currentColor" strokeWidth="1.5" fill="none" />
            <circle cx="25" cy="15" r="2" fill="currentColor" />
            <circle cx="75" cy="15" r="2" fill="currentColor" />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#traditional-waves)" />
      </svg>
    ),
    geometric: (
      <svg className={`absolute inset-0 w-full h-full ${className}`} style={{ opacity }}>
        <defs>
          <pattern id="traditional-geometric" x="0" y="0" width="80" height="80" patternUnits="userSpaceOnUse">
            <rect x="10" y="10" width="25" height="25" fill="none" stroke="currentColor" strokeWidth="1.5" />
            <circle cx="22.5" cy="22.5" r="8" fill="currentColor" />
            <rect x="45" y="45" width="25" height="25" fill="none" stroke="currentColor" strokeWidth="1.5" />
            <circle cx="57.5" cy="57.5" r="8" fill="currentColor" />
            <path d="M35 10 L45 20 L35 30 L25 20 Z" fill="none" stroke="currentColor" strokeWidth="1" />
            <path d="M10 45 L20 55 L10 65 L0 55 Z" fill="currentColor" opacity="0.6" />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#traditional-geometric)" />
      </svg>
    ),
    image: (
      <div 
        className={`absolute inset-0 w-full h-full ${className}`} 
        style={{ 
          backgroundImage: 'url(/images/patterns.jpeg)',
          backgroundSize: '200px 200px',
          backgroundRepeat: 'repeat',
          opacity
        }}
      />
    )
  };

  return patterns[variant] || patterns.circles;
};

export default TraditionalPattern;
